
export default function Nft(props) {
    return (
        <div>
            <img style={{
                width: 250 * 0.887043189,
                // height: 250
            }} className='' src={props.src} alt="" />
        </div>
    )
}